// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sB0Q","content":"styles_content__12KI3","row":"styles_row__1bkL4","footer":"styles_footer__1ahWM","phraseLength":"styles_phraseLength__1V1Wb"};